import React from 'react';

import { useTranslation } from '@lyearn/i18n';
import { cn } from '@lyearn/style';
import { Stack, Typography } from '@lyearn/ui';

import { FrequencyComponentProps } from '../../../types';
import TimeOfDay from '../../InputComponents/TimeOfDay';
import IntervalInput from './CustomInputComponents/IntervalInput';
import MultiWeekday from './CustomInputComponents/MultiWeekday';
import CustomFrequencyInput from './CustomFrequencyInput';

const CustomWeek: React.FC<FrequencyComponentProps> = React.memo((props) => {
  const {
    value,
    onChange,
    hideTimeSelection,
    disabled,
    allowedCustomFrequencies,
    errorConfig,
    size,
  } = props;
  const { t } = useTranslation();

  return (
    <Stack direction="col" gapY={16}>
      <Stack justifyContent="start">
        <Stack alignItems="start" className="w-1/2 space-s-8">
          <IntervalInput disabled={disabled} size={size} value={value} onChange={onChange} />
          <CustomFrequencyInput
            allowedCustomFrequencies={allowedCustomFrequencies}
            disabled={disabled}
            size={size}
            value={value}
            onChange={onChange}
          />
        </Stack>
        <Stack className="w-1/2">
          <Typography
            className={cn('mx-12 my-auto', { 'pb-24': Boolean(errorConfig?.daysOfWeek) })}
            variant={size === 'medium' ? 'body-short-02' : 'body-short-01'}>
            {t('On')}
          </Typography>
          <MultiWeekday
            disabled={disabled}
            error={errorConfig?.daysOfWeek}
            size={size}
            value={value}
            onChange={onChange}
          />
        </Stack>
      </Stack>
      {hideTimeSelection ? null : (
        <TimeOfDay disabled={disabled} size={size} value={value} onChange={onChange} />
      )}
    </Stack>
  );
});

export default CustomWeek;
